export enum MENU_ITEMS {
  TAGS = 'tags',
  TAGS_CONTACT = 'tagsContact',
  TAGS_ROOM = 'tagsRoom',
  CANNED_MESSAGES = 'cannedMessages',
  CUSTOM_FIELDS = 'customFields',
  CONVERSATIONS = 'conversations',
  TEAMS = 'teams',
  USERS = 'users',
  OVERVIEW = 'overview',
  SALESDESK_PERFORMANCE = 'salesdesk_performance',
  AGENTS_PERFORMANCE = 'agents_performance',
  CSAT = 'csat_salesdesk',
  ANALYTICS = 'analytics',
  VERIFIED_TEMPLATES = 'verified-templates',
  CHAT_COPILOT_ASSISTANT = 'chat-copilot-assistant',
  BUSINESS_HOURS = 'business-hours.title',
}

export enum MENU_ROUTE_PARAM {
  USERS = 'users',
  TEAMS = 'teams',
  CONVERSATIONS = 'conversations',
  CUSTOM_FIELDS = 'custom-fields',
  CANNED_MESSAGES = 'canned-messages',
  TAGS = 'tags',
  TAGS_CONTACT = 'contact',
  TAGS_ROOM = 'room',
  ANALYTICS = 'analytics',
  OVERVIEW = 'overview',
  SALESDESK_PERFORMANCE = 'team',
  AGENTS_PERFORMANCE = 'agents',
  CSAT = 'csat',
  VERIFIED_TEMPLATES = 'verified-templates',
  CHAT_COPILOT_ASSISTANT = 'copilot-assistant',
  BUSINESS_HOURS = 'business-hours',
}

export enum TagManagerTypes {
  VISITOR = 'visitor',
  ROOM = 'room',
}

export enum AnalyticsTypes {
  OVERVIEW = 'overview',
  AGENTS_PERFORMANCE = 'agents_performance',
  SALESDESK_PERFORMANCE = 'salesdesk_performance',
  CSAT_SALESDESK = 'csat_salesdesk',
}

export type MenuItemsType = `${MENU_ITEMS}`;

export interface IMenuItem {
  key: MenuItemsType;
  name: string;
  routeParam: MENU_ROUTE_PARAM;
  type?: string;
}

export interface ISidebarItem extends IMenuItem {
  icon: React.ReactElement;
  featureFlagName?: string;
  permission?: string;
  subItems?: IMenuItem[];
  /**
   * If true, the item will not redirect to the first subItem when no subsection is specified in the URL.
   * @default false
   */
  skipSubItemRedirect?: boolean;
}

export interface IRenderListItem {
  index: number;
  item: ISidebarItem;
}

/**
 * Route params structure for ServiceManagement routes
 */
export interface RouteParams extends Record<string, string | undefined> {
  section?: string;
  subsection?: string;
}
